import { ErrorResponse } from '@src/interface/api/response.interface'
import { signout, SignoutResponse } from '@src/lib/api/auth/signout'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const useSignoutQuery = (): UseMutationResult<SignoutResponse, AxiosError<ErrorResponse>> => {
	return useMutation(() => signout())
}

export default useSignoutQuery
